import { render, staticRenderFns } from "./VNewTokenInput.vue?vue&type=template&id=1335e320&scoped=true"
import script from "./VNewTokenInput.vue?vue&type=script&lang=js"
export * from "./VNewTokenInput.vue?vue&type=script&lang=js"
import style0 from "./VNewTokenInput.vue?vue&type=style&index=0&id=1335e320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1335e320",
  null
  
)

export default component.exports